// extracted by mini-css-extract-plugin
export default {"container":"LeftNavbar_container__1PuaT","logo":"LeftNavbar_logo__a9zcn","img":"LeftNavbar_img__AXKvD"};